module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_13_sp-b4bda8d4b4850155ac74ee08b57551a6.png";